import { t, useI18n } from "@bookingcom/lingojs-react";
import useSearchFiltersController from "../../useSearchFiltersController.js";
import { useState } from "react";
import { ArrowNavUpIcon, ArrowNavDownIcon } from "@bookingcom/bui-assets-react/streamline";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
const limit = 5;
export const useAirlinesFilterController = () => {
    const i18n = useI18n();
    const { airlines } = useSearchFiltersController();
    const [trucanteOptions, setTruncateOptions] = useState(true);
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    const handleOnChange = (checked, value) => {
        airlines.set(checked ? [...airlines.value, value] : airlines.value.filter((v) => v !== value));
    };
    const handleSelectSingleOption = (value) => {
        airlines.set([value]);
    };
    return {
        isFilterAvailable: airlines.options.length > 0,
        title: i18n.trans(t("flights_filter_airlines")),
        resetLabel: i18n.trans(t("flights_filter_reset")),
        options: airlines.options,
        showReset: trackLayoverPriceAirportFilterWeb() ? false : airlines.touched,
        onClickReset: () => {
            airlines.reset();
        },
        value: airlines.value,
        onChange: (checked, value) => {
            handleOnChange(checked, value);
        },
        onSelectSingleOption: (value) => {
            handleSelectSingleOption(value);
        },
        optionsLimit: limit,
        optionsTogglerLabel: trucanteOptions
            ? i18n.trans(t("flights_filters_show_more_action"))
            : i18n.trans(t("flights_filters_show_less_action")),
        optionsTogglerAriaLabel: trucanteOptions
            ? i18n.trans(t("flights_filters_airlines_view_more"))
            : i18n.trans(t("flights_filters_airlines_view_fewer")),
        optionsTogglerIcon: trucanteOptions ? ArrowNavDownIcon : ArrowNavUpIcon,
        singleOptionLabel: i18n.trans(t("flights_filter_airline_only")),
        onTogglerClick: () => setTruncateOptions((s) => !s),
        areOptionsTrucanted: trucanteOptions,
        selectAllTogglerLabel: i18n.trans(t("flights_select_all_toggle")),
        deselectAllTogglerLabel: i18n.trans(t("flights_deselect_all_toggle")),
        onSelectAll: () => {
            airlines.set(airlines.options.map((a) => a.value));
        },
        isSelectAllDisabled: airlines.value.length === airlines.options.length,
        onDeselectAll: () => {
            airlines.set([]);
        },
        isDeselectAllDisabled: airlines.value.length === 0
    };
};
